// extracted by mini-css-extract-plugin
export default {"partnerLogo":"partnerLogo__HJ2mk","partnerImage":"partnerImage__NNPU8","partnerBar":"partnerBar__H05XG","telekom":"telekom__erxeD"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"partnerLogo\":\"partnerLogo__HJ2mk\",\"partnerImage\":\"partnerImage__NNPU8\",\"partnerBar\":\"partnerBar__H05XG\",\"telekom\":\"telekom__erxeD\"}";
        // 1787130556863
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  